import script from "./HomeIconList.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeIconList.vue?vue&type=script&setup=true&lang=js"

import "./HomeIconList.vue?vue&type=style&index=0&id=22a108ad&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a108ad"]])

export default __exports__